// Status color utility matching noticeboard card colors

export type StatusColor = 'yellow' | 'orange' | 'green' | 'blue' | 'gray';

export const statusColorClasses: Record<
  StatusColor,
  { bg: string; border: string; text: string }
> = {
  yellow: {
    bg: 'bg-amber-50',
    border: 'border-amber-400',
    text: 'text-amber-700',
  },
  orange: {
    bg: 'bg-orange-50',
    border: 'border-orange-400',
    text: 'text-orange-700',
  },
  green: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-400',
    text: 'text-emerald-700',
  },
  blue: {
    bg: 'bg-sky-50',
    border: 'border-sky-400',
    text: 'text-sky-700',
  },
  gray: {
    bg: 'bg-gray-50',
    border: 'border-gray-300',
    text: 'text-gray-700',
  },
};

export function getInboundStatusColor(status: string): StatusColor {
  switch (status) {
    case 'Awaiting Delivery':
      return 'gray';
    case 'Arrived':
    case 'Arrived. Processing':
      return 'yellow';
    case 'Received & Put Away':
    case 'Delivered':
      return 'green';
    case 'Quality Check Pending':
      return 'blue';
    default:
      return 'gray';
  }
}

export function getOutboundStatusColor(status: string): StatusColor {
  switch (status) {
    case 'Picked & Packed':
    case 'Awaiting Pick-Up':
    case 'Awaiting Pick up':
      return 'yellow';
    case 'In Picking':
      return 'blue';
    case 'In Transit':
      return 'orange';
    case 'Delivered':
    case 'Fulfilled Externally':
      return 'green';
    default:
      return 'gray';
  }
}

export function getStatusBadgeClasses(color: StatusColor): string {
  const colors = statusColorClasses[color];
  return `inline-flex items-center px-2.5 py-0.5 rounded border ${colors.border} ${colors.bg} text-xs font-medium ${colors.text}`;
}

export function getStatusHeaderBadgeClasses(color: StatusColor): string {
  const colors = statusColorClasses[color];
  return `inline-flex items-center px-2.5 py-0.5 rounded border ${colors.border} bg-white text-xs font-medium ${colors.text}`;
}

export function getStatusHeaderClasses(color: StatusColor): string {
  const colors = statusColorClasses[color];
  return `${colors.bg} border-b-2 ${colors.border}`;
}
